import useGetCompanyUserById from "./useGetCompanyUserById";


export default {
  useGetCompanyUserById
};